// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#security {
    margin-right: 15px;
    opacity: 1;
    transition: all 1s;
   -webkit-transition: all 1s;
}

#security:hover {
       opacity:0;
       transition: all 1s;
       -webkit-transition: all 1s;
}

.noScrolling{
       width: 150px;
       height: 165px;      
       overflow: hidden;
     }`, "",{"version":3,"sources":["webpack://./src/app/components/security/security.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;GACnB,0BAA0B;AAC7B;;AAEA;OACO,SAAS;OACT,kBAAkB;OAClB,0BAA0B;AACjC;;AAEA;OACO,YAAY;OACZ,aAAa;OACb,gBAAgB;KAClB","sourcesContent":["#security {\r\n    margin-right: 15px;\r\n    opacity: 1;\r\n    transition: all 1s;\r\n   -webkit-transition: all 1s;\r\n}\r\n\r\n#security:hover {\r\n       opacity:0;\r\n       transition: all 1s;\r\n       -webkit-transition: all 1s;\r\n}\r\n\r\n.noScrolling{\r\n       width: 150px;\r\n       height: 165px;      \r\n       overflow: hidden;\r\n     }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
